import("../src/javascripts/easy-toggle");
import("../src/javascripts/navigation");
import("../src/javascripts/slider_splide");
import("../src/javascripts/smooth-scroll-to-anchor");
